// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-item-container-mjPuJ {
  padding: 14px 0px;
  border-bottom: 1px solid var(--border-color);
}

.text-item-title-leXEy {
  display: block;
  font-size: 15px;
  font-weight: 500;
}

.text-item-content-fFjky {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.text-item-text-wydQy {
  display: block;
  font-family: Roboto;
  font-size: 17px;
  overflow: hidden;
}

.text-item-icon-JVDAc {
  --size: 20px;
  flex-shrink: 0;
  margin-left: 12px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/text-item/text-item.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".container {\n  padding: 14px 0px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.title {\n  display: block;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 8px;\n}\n\n.text {\n  display: block;\n  font-family: Roboto;\n  font-size: 17px;\n  overflow: hidden;\n}\n\n.icon {\n  --size: 20px;\n  flex-shrink: 0;\n  margin-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `text-item-container-mjPuJ`,
	"title": `text-item-title-leXEy`,
	"content": `text-item-content-fFjky`,
	"text": `text-item-text-wydQy`,
	"icon": `text-item-icon-JVDAc`
};
export default ___CSS_LOADER_EXPORT___;
